"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isRunningOnClient = _interopRequireDefault(require("./is-running-on-client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// NOTE: https://stackoverflow.com/questions/45061901/chrome-61-body-doesnt-scroll
var scrollingElement = _isRunningOnClient["default"] ? document.scrollingElement || document.documentElement || document.body : undefined;
var _default = scrollingElement;
exports["default"] = _default;